import './Advantages.css';
import timeIcon from '../assets/time-icon.png';
import moneyIcon from '../assets/money-icon.webp';
import devIcon from '../assets/develop-icon.webp';
import { useTranslation } from 'react-i18next';
import { Trans } from 'react-i18next';


export default function Advantages() {
    const { t, i18n } = useTranslation();
    return(
        <section className='advantages-section'>
            <h1 className='advantages-title'>
                <Trans
                    i18nKey="$Header6"
                    components={{ highlight: <span className='advantages-title-colored' /> }}
                />
            </h1>
            <div className='advantages-blocks'>
                <div className='advantages-block'>
                    <img src={timeIcon} className='advanatges-block-icon' alt='advantages-time-icon'/>
                    <h1 className='advantages-block-header'>
                        {t('$Eff_1')}
                    </h1>
                    <p className='advantages-block-descr'>
                        Получайте готовые шаблоны и проверенные решения за считанные минуты вместо долгих поисков и экспериментов — фокусируйтесь на выполнении задач, а не на их подготовке.
                    </p>
                </div>
                <div className='advantages-block'>
                    <img src={moneyIcon} className='advanatges-block-icon' alt='advantages-money-icon' />
                    <h1 className='advantages-block-header'>
                        {t('$Eff_2')}
                    </h1>
                    <p className='advantages-block-descr'>
                        {t('$Text2')}
                    </p>
                </div>
                <div className='advantages-block'>
                    <img src={devIcon} className='advanatges-block-icon' alt='advantages-develope-icon' />
                    <h1 className='advantages-block-header'>
                        {t('$Eff_3')}
                    </h1>
                    <p className='advantages-block-descr'>
                        {t('$Text3')}
                    </p>
                </div>
            </div>
        </section>
    );
}